import { Component, OnInit } from '@angular/core';
import { PagedResponse } from '@shared/models/paged-response';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@shared/models/page-event';
import { Dealer } from '@shared/models/dealer';
import Utils from '@shared/utils/utils';
import { ApiService } from '@shared/apis';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { SpinnerService } from '@shared/services/spinner.service';
import { UserService } from '@routes/users/shared/user.service';
import { Subject } from 'rxjs';
import { DealerLocation } from '@shared/models/dealer-location';
import { AuthService } from '@core/auth/auth.service';

@Component({
  selector: 'app-assign-dealer',
  templateUrl: './assign-location-alias.component.html',
  styleUrls: ['./assign-location-alias.component.scss']
})
export class AssignLocationAliasComponent implements OnInit {

  userInfo: any;
  // dealers: any;
  assignedLocationAliases: any;
  unAssignedAliases: any;

  options = { autoHide: true, scrollbarMaxSize: 100 };

  /** assign and unassign buttons */
  assign: any;
  assignedList: any[] = [];
  unassignedList: any[] = [];
  unAssign: any;
  sample: any;

  dealerLocations!: DealerLocation[];
  selectedData: Dealer;

  query: any;
  q: any;
  pagedResponse: PagedResponse;
  searchText = new FormControl(null);

  parentSelector: boolean = false;

  public onClose: Subject<any> = new Subject();
  dealerSelectGroup!: Dealer[];

  constructor(
    private apiService: ApiService,
    private bsModalRef: BsModalRef,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private userService: UserService,
  ) {
  };

  ngOnInit(): void {
    this.getDealerList();
    this.getAssignedLocationAliases(this.userInfo.username);
    this.showList();
    this.searchText.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(text => {
        this.q = text;
        this.showList();
      });
  }

  onAssignChangeSelect($event) {
    const bpNo = $event.target.value;
    const isChecked = $event.target.checked;


    if (isChecked === true) {
      if (bpNo !== '-1') {
        this.assignedList.push(bpNo);
      }
    } else {
      const index: number = this.assignedList.indexOf(bpNo);
      this.assignedList.splice(index, 1);
    }
  }

  onUnAssignChangeSelect($event) {
    const id = $event.target.value;
    const isChecked = $event.target.checked;
    if (isChecked === true) {
      this.unassignedList.push(id);
    } else {
      const index: number = this.unassignedList.indexOf(id);
      this.unassignedList.splice(index, 1);
    }
  }

  getAssignedLocationAliases(username) {
    this.apiService.user.getMyLocationAliases(username)
      .subscribe((res: any[]) => {
        this.assignedLocationAliases = res;
      });
  }

  assignLocationAliases() {
    const assignLocationAliases = { assignLocationAliases: this.unassignedList };
    this.apiService.user.assignLocationAliases(this.userInfo.username, assignLocationAliases)
      .subscribe((res: any[]) => {
        this.assign = res;
        this.unassignedList = [];
        this.reload();
      });
  }

  unAssignLocationAliases() {
    const unAssignLocationAliases = { unAssignLocationAliases: this.assignedList };
    this.apiService.user.unAssignLocationAliases(this.userInfo.username, unAssignLocationAliases)
      .subscribe((res: any[]) => {
        this.unAssign = res;
        this.assignedList = [];
        this.reload();
      });
  }

  onPageEvent(pageEvent: PageEvent) {
    this.showList(pageEvent);
  }

  showList(pageEvent?: PageEvent) {
    this.spinnerService.start();
    this.unAssignedAliases = this.apiService.dealer.getUnAssignedLocationAliases(pageEvent, this.q, this.query, this.userInfo.username)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.pagedResponse = res;
        this.dealerLocations = res.docs.map((m) => {
          return m;
        });
      }, err => Utils.showError(err));
  }

  reload() {
    this.getAssignedLocationAliases(this.userInfo.username);
    this.showList();
    this.userService.detailReload$.next(true);
  }

  close() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  changeDealer(e) {
    if (e && e.bpNo) {
      this.query = { $or: [{ bpNo: e.bpNo }, { hqBpNo: e.bpNo }] };
    } else {
      this.query = {};
    }
    this.showList();
  }

  getDealerList() {
    this.dealerSelectGroup = this.authService.getHQDealers();
  }
}
